<template>
  <div>
    <b-container class="pb-3 px-0">
      <div class="d-flex flex-row justify-content-end">
        <InventorySectionFilter
          v-on:onSubmitFilter="onSubmitFilter"
          name="Offline"
          ref="inventorySectionFilter"
        />
      </div>
    </b-container>

    <b-table
      ref="table"
      id="table-product"
      class="text-center table-list mb-0 bg-white"
      striped
      responsive
      :items="items"
      :fields="fields"
      :busy="isBusy"
      show-empty
      empty-text="ไม่พบข้อมูล"
    >
      <template #cell(imageUrl)="data">
        <div class="position-relative">
          <div
            class="square-box b-contain"
            v-bind:style="{
              backgroundImage: 'url(' + data.item.imageUrl + ')',
            }"
          ></div>
        </div>
      </template>

      <template #cell(productName)="data">
        <div class="product-name">
          <p class="mb-0">
            {{ data.item.productName }}
          </p>
          <p class="mb-0 text-gray1 f-size-14">
            SKU: {{ data.item.productSKU }}
          </p>
          <p class="mb-0 text-gray1 f-size-14">
            Collection: {{ data.item.collection }}
          </p>
        </div>
      </template>

      <template #cell(totalStock)="data">
        <div>{{ data.item.totalStock | numeral("0,0") }}</div>
        <b-badge
          v-if="data.item.stockStatus == 'เหลือน้อย'"
          pill
          variant="warning"
          class="px-3 text-white"
          >เหลือน้อย</b-badge
        >
      </template>

      <template #cell(offlineStock)="data">
        <div>{{ data.item.offlineStock | numeral("0,0") }}</div>
      </template>

      <template
        v-for="field in fields.slice(4)"
        v-slot:[`cell(${field.key})`]="data"
      >
        <div :key="field.key">
          <span
            v-if="!data.item.edit"
            :id="'valueEditStockOffline' + data.item.productId"
            >{{ data.item[field.key] }}</span
          >

          <InputTextStock
            :id="'inputEditStockOffline' + data.item.productId"
            v-if="data.item.edit"
            textFloat=""
            placeholder=""
            type="number"
            :name="field.key"
            isRequired
            :value="data.item[field.key]"
            :isValidate="$v.items.$each.$iter[data.index][field.key].$error"
            :v="$v.items.$each.$iter[data.index][field.key]"
            @onDataChange="changeVal(data.index, field.key, $event)"
          />

          <!-- <p :id="'stockOffline' + data.item.productId" v-else class="mb-0">
            {{ data.item[field.key] | numeral("0,0") }}
          </p> -->
        </div>
      </template>

      <template #cell(action)="data">
        <div class="position-relative" v-if="!data.item.edit">
          <font-awesome-icon
            @click="editStock(data.index)"
            icon="pencil-alt"
            title="Edit"
            class="icon-edit"
            :id="'btnEditStockOffline' + data.item.productId"
          />
        </div>
        <div v-else>
          <b-button
            @click="submitStock(data.index, data.item)"
            :id="'btnSaveStockOffline' + data.item.productId"
            class="button-container btn-main"
            >บันทึก</b-button
          >
        </div>
      </template>
    </b-table>

    <b-row class="no-gutters px-3 px-sm-0 bg-white" v-if="!isBusy">
      <b-col class="form-inline justify-content-center justify-content-sm-end">
        <div class="d-sm-flex m-3">
          <b-pagination
            v-model="filterInventoryList.page"
            :total-rows="rows"
            :per-page="filterInventoryList.pageSize"
            class="m-md-0 page-item"
            @change="pagination"
          ></b-pagination>
        </div>
        <b-form-select
          class="mr-sm-3 select-page"
          v-model="filterInventoryList.pageSize"
          @change="handleChangePerpage"
          :options="pageOptions"
        ></b-form-select>
      </b-col>
    </b-row>
    <ModalLoading ref="modalLoadingUpdateStock" :hasClose="false" />
    <ModalAlert ref="modalUpdateStockSuccess" text="บันทึกสำเร็จ" />
    <ModalAlertError ref="modalUpdateStockError" :text="textAlert" />
  </div>
</template>

<script>
import { required, minValue, numeric, integer } from "vuelidate/lib/validators";
import InventorySectionFilter from "../inventory-filter/InventorySectionFilter.vue";
import InputTextStock from "../input/InputTextStock.vue";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";

export default {
  components: {
    InventorySectionFilter,
    InputTextStock,
    ModalLoading,
    ModalAlert,
    ModalAlertError,
  },
  data() {
    return {
      called: false,
      isBusy: false,
      rows: 0,
      totalCount: 0,
      textAlert: "",
      listAllDataId: [],
      branch: [],
      filterInventoryList: {
        search: "",
        productInventoryTypes: [],
        productStatus: [],
        categories: [0, 0, 0, 0],
        stockStatus: [3],
        StartDate: "",
        EndDate: "",
        page: 1,
        pageSize: 10,
        collections: "",
      },
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      items: [],
      fields: [
        {
          key: "imageUrl",
          label: "ภาพสินค้า",
          class: "w-100px text-nowrap",
        },
        {
          key: "productName",
          label: "ชื่อสินค้า/SKU",
          class: "w-100px text-nowrap",
        },
        {
          key: "totalStock",
          label: "คลังรวม",
          class: "w-90px text-nowrap",
        },
        {
          key: "offlineStock",
          label: "Offline",
          class: "w-90px text-nowrap",
        },
      ],
      oldVal: {},
    };
  },
  async created() {
    await this.getFilter();
    this.$refs.inventorySectionFilter.setFilter({
      ...this.filterInventoryList,
    });
    this.getProductList();
  },
  validations() {
    const rules = { items: { $each: {} } };
    const sumStock = (item) => {
      let totalStock = 0;
      for (const key in item) {
        if (
          key !== "imageUrl" &&
          key !== "productId" &&
          key !== "productName" &&
          key !== "productSKU" &&
          key !== "collection" &&
          key !== "stockStatus" &&
          key !== "totalStock" &&
          key !== "edit" &&
          key !== "offlineStock" &&
          item[key] !== "" &&
          item[key] > 0
        ) {
          totalStock += parseInt(item[key]);
        }
      }
      return totalStock;
    };

    this.fields.forEach((item, index) => {
      if (
        item.key !== "imageUrl" &&
        item.key !== "productName" &&
        item.key !== "totalStock" &&
        item.key !== "offlineStock" &&
        item.key !== "action"
      ) {
        rules.items.$each[`${item.key}`] = {
          required: required,
          minValue: minValue(0),
          numeric: numeric,
          integer: integer,
          isOverTotalStock(value, value2) {
            if (sumStock(value2) > value2.totalStock) {
              return false;
            } else {
              return true;
            }
          },
        };
      } else {
        rules.items.$each[`${item.key}`] = {};
      }
    });
    return rules;
  },
  methods: {
    getFilter() {
      if (this.$route.query.search) {
        this.filterInventoryList.search = this.$route.query.search;
      }
      if (this.$route.query.productInventoryTypes) {
        this.filterInventoryList.productInventoryTypes = this.$route.query.productInventoryTypes
          .split(",")
          .map(Number);
      }
      if (this.$route.query.productStatus) {
        this.filterInventoryList.productStatus = this.$route.query.productStatus
          .split(",")
          .map(Number);
      }
      if (this.$route.query.categories) {
        this.filterInventoryList.categories = this.$route.query.categories
          .split(",")
          .map(Number);
      }
      if (this.$route.query.stockStatus) {
        this.filterInventoryList.stockStatus = this.$route.query.stockStatus
          .split(",")
          .map(Number);
      }
      if (this.$route.query.StartDate) {
        this.filterInventoryList.StartDate = this.$route.query.StartDate;
      }
      if (this.$route.query.EndDate) {
        this.filterInventoryList.EndDate = this.$route.query.EndDate;
      }
      if (this.$route.query.page) {
        this.filterInventoryList.page = parseInt(this.$route.query.page) || 1;
      }
      if (this.$route.query.pageSize) {
        this.filterInventoryList.pageSize =
          parseInt(this.$route.query.pageSize) || 10;
      }
      if (this.$route.query.collections) {
        this.filterInventoryList.collections = this.$route.query.collections;
      }
    },
    setFilter(filter) {
      let filterInventoryList = this.filterInventoryList;
      if (filter) filterInventoryList = filter;
      this.$router
        .push({
          path: "/inventory",
          query: {
            brandID: this.$route.query.brandID,
            search: filterInventoryList.search,
            productInventoryTypes: filterInventoryList.productInventoryTypes.toString(),
            productStatus: filterInventoryList.productStatus.toString(),
            categories: filterInventoryList.categories.toString(),
            stockStatus: filterInventoryList.stockStatus.toString(),
            StartDate: filterInventoryList.StartDate || "",
            EndDate: filterInventoryList.EndDate || "",
            pageSize: filterInventoryList.pageSize,
            page: filterInventoryList.page,
            collections: filterInventoryList.collections,
            tab: this.$route.query.tab || 1,
          },
        })
        .catch((err) => {});
    },
    async getProductList() {
      this.isBusy = true;

      await this.axios
        .post(
          `${this.$baseUrl}/stockdistribute/offline`,
          this.filterInventoryList
        )
        .then((data) => {
          this.rows = data.totalCount;
          // this.items = data.data.product;
          this.branch = data.data.branch;
          this.totalCount = data.totalCount;
          this.listAllDataId = data.listAllDataId;
          this.items = [];
          for (const i in data.data.product) {
            var newItem = {
              imageUrl: data.data.product[i]["imageUrl"],
              productId: data.data.product[i]["productId"],
              productName: data.data.product[i]["productName"],
              productSKU: data.data.product[i]["productSKU"],
              collection: data.data.product[i]["collection"],
              stockStatus: data.data.product[i]["stockStatus"],
              totalStock: data.data.product[i]["totalStock"],
              offlineStock: data.data.product[i]["offlineStock"],
            };
            for (const j in data.data.product[i]["branch"]) {
              newItem[data.data.product[i]["branch"][j].branchId] =
                data.data.product[i]["branch"][j].stock;
            }
            this.items.push(newItem);
          }
        });
      this.addFields();
      this.isBusy = false;
    },
    addFields() {
      if (!this.called) {
        for (const i in this.branch) {
          this.fields.push({
            key: this.branch[i].branchId.toString(),
            label: this.branch[i].branchName,
            class: "w-80px text-nonwrap",
          });
        }

        this.fields.push({
          key: "action",
          label: "",
          class: "w-80px text-nonwrap",
        });
        this.called = true;
      }
    },
    pagination(Page) {
      this.filterInventoryList.page = Page;
      this.setFilter();
      this.getProductList();
    },
    handleChangePerpage(value) {
      this.filterInventoryList.pageSize = value;
      this.setFilter();
      this.getProductList();
    },
    onSubmitFilter(filter) {
      this.setFilter(filter);
      this.getInventoryList(filter);
    },
    getInventoryList(filter) {
      this.filterInventoryList = filter;
      this.filterInventoryList.page = 1;
      this.setFilter();
      this.getProductList();
    },
    editStock(index) {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].edit) {
          for (const key in this.oldVal) {
            this.items[i][key] = this.oldVal[key];
          }
          this.items[i].edit = false;
        }
      }

      this.items[index].edit = true;
      this.setOldVal(index);
      this.$refs.table.refresh();
    },
    submitStock(index, item) {
      this.$v.items.$each.$iter[index].$touch();
      if (this.$v.items.$each.$iter[index].$error) {
        return;
      }
      this.$refs.modalLoadingUpdateStock.show();
      let stock = [];
      for (const key in item) {
        if (
          key !== "imageUrl" &&
          key !== "productId" &&
          key !== "productName" &&
          key !== "productSKU" &&
          key !== "collection" &&
          key !== "stockStatus" &&
          key !== "totalStock" &&
          key !== "edit" &&
          key !== "offlineStock"
        ) {
          stock.push({
            BranchId: key,
            Quantity: parseInt(item[key]),
          });
        }
      }
      let stockUpdate = {
        ProductId: item.productId,
        Stock: stock,
        ReferenceTypeId: 1,
      };

      this.axios
        .post(`${this.$baseUrl}/stockdistribute/stockoffline`, stockUpdate)
        .then((data) => {
          this.$refs.modalLoadingUpdateStock.hide();
          if (data.result == 0) {
            this.textAlert = data.detail;
            this.$refs.modalUpdateStockError.show();
          } else {
            this.$refs.modalUpdateStockSuccess.show();
            this.getProductList();
          }
        })
        .catch((error) => {
          console.log("error: " + error);
          this.$refs.modalLoadingUpdateStock.hide();
          this.textAlert = "บันทึกไม่สำเร็จ";
          this.$refs.modalUpdateStockError.show();
        });

      this.items[index].edit = false;
      this.$refs.table.refresh();
    },
    changeVal(index, fieldKey, val) {
      this.setOldVal(index);
      this.items[index][fieldKey] = val;
    },
    setOldVal(index) {
      for (const key in this.items[index]) {
        if (
          key !== "imageUrl" &&
          key !== "productId" &&
          key !== "productName" &&
          key !== "productSKU" &&
          key !== "collection" &&
          key !== "stockStatus" &&
          key !== "totalStock" &&
          key !== "edit" &&
          key !== "offlineStock"
        ) {
          this.oldVal[key] = this.items[index][key];
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.img-product {
  width: 100%;
  padding-bottom: 100.5%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
/deep/ .table > tbody > tr > td {
  min-width: 100px;
  // background-color: #f1f1f1;
  // border-bottom: solid 1px black;
}
.product-name {
  width: 300px;
  text-align: left;
}
a:hover {
  color: #b41bb4;
  text-decoration: underline;
  cursor: pointer;
}
.cancel-button {
  background-color: white;
  width: 150px;
}
.link-remove-info {
  color: #b41bb4;
  text-decoration: underline;
}
a {
  color: #b41bb4;
  text-decoration: underline;
}
.text-purple {
  color: #b41bb4;
}
.badge-percent {
  background-color: #b41bb4;
  color: white;
}
.market-percent {
  color: #092d53;
}
.icon-edit {
  cursor: pointer;
}
// /deep/ .table td {
//     text-align: center;
//     vertical-align: top;
//     border: none;
// }
</style>
